import { DocumentNode } from '@apollo/client/core';
import { addClientAlwaysDirective } from 'src/database/addClientAlwaysDirective.ts';
import { removeDuplicateFragmentsLogic } from 'src/utils/removeDuplicateFragmentsLogic.ts';

/**
 * workaround for removing duplicated fragment definitions at runtime
 * @TODO tune codegen to apply this workaround
 * @See more info on the issue and third party solution https://www.npmjs.com/package/gql-dedup
 * @param doc
 */
export function removeDuplicateFragments(doc: DocumentNode) {
    return addClientAlwaysDirective(removeDuplicateFragmentsLogic(doc));
}
